module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-field', {
    staticClass: "file"
  }, [_c('b-upload', {
    model: {
      value: (_vm.file),
      callback: function($$v) {
        _vm.file = $$v
      },
      expression: "file"
    }
  }, [_c('a', {
    staticClass: "button is-primary"
  }, [_c('b-icon', {
    attrs: {
      "icon": "upload"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Click to upload")])], 1)]), _vm._v(" "), (_vm.file) ? _c('span', {
    staticClass: "file-name"
  }, [_vm._v("\n            " + _vm._s(_vm.file.name) + "\n        ")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f3b3eea2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/upload/examples/ExSimple.vue
// module id = 1283
// module chunks = 36 63